import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { handle } from './wrapper.js'
import { modifiers } from '#components/generics/js/styles.js'

const bubbling = object(null, {
  bubbles: true
})

const handler = (select, fieldTime) => {
  const inputHidden = one(`.${modifiers.new_field_input.new_hidden}`, fieldTime)
  const inputText = one(`.${modifiers.new_field_input.new_text}`, fieldTime)
  const { selectedIndex, selectedOptions, ownerDocument } = select
  const { defaultView } = ownerDocument
  const { InputEvent } = defaultView
  const option = selectedOptions[selectedIndex]

  inputHidden.value = select.value
  inputText.value = option.text
  inputText.focus()
  inputText.dispatchEvent(new InputEvent('input', bubbling))
}

export default select => {
  handle(select, handler)
}
